import { useState } from 'react';

const ResourceThumb = ({ thumbnail, Icon, tile }) => {
  const [errored, setErrored] = useState(false);
  if (thumbnail && !errored) {
    return (
      <span className='flex h-9 w-9 shrink-0 overflow-hidden rounded-lg bg-white'>
        <img
          src={thumbnail}
          alt=''
          loading='lazy'
          onError={() => setErrored(true)}
          className='h-full w-full object-cover'
        />
      </span>
    );
  }
  return (
    <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-lg ${tile}`}>
      <Icon fontSize='small' />
    </span>
  );
};

export default ResourceThumb;
